import $ from 'jquery';

/**
 * Custom Scripts
 */
// import Form from './custom/forms';
// import SocialMedia from './custom/bjzm-social-feeds';
import BjzmScripts from './custom/bjzm-scripts';
import BjzmSlideshows from './custom/bjzm-slideshow.js';

import BjzmParallax from './custom/bjzm-parallax';

import BjzmLoadMorePosts from './custom/bjzm-load-more-posts';
import HeaderScroll from './custom/header-scroll';
import SinglePageUpdown from './custom/single-page-updown';
// import BjzmFormScripts from './custom/bjzm-form-scripts';
import Floorplans from './custom/floorplans';


import Toggles from './custom/toggles';
import ThemeMortgageCalculator from './custom/mortgage-calculator';
import SingleMap from './custom/single-map';

// import 'selectric';

/**
 * Vendors
 */
import matchHeight from './vendors/jquery.matchHeight';
import magnificPopup from 'magnific-popup';
import dropdown from './vendors/jquery.dropdown.min';


var DoSingleMap = function() {
	console.log('who this is cool');
}

jQuery(document).ready(function($) {

 	var ThemeScripts = new BjzmScripts();
 	var NewBjzmParallax = new BjzmParallax();

 	new ThemeMortgageCalculator();
 	new SingleMap();
 	
	var ThemeToggle = new Toggles();
	var ThemeSliders = new BjzmSlideshows();
	
	if( "9065" == BJZM_DATA.ID || "11347" == BJZM_DATA.ID ) {
		new Floorplans();
	}

	$(".card-image-faker").on('click', function(){
		var link = $(this).data('link');
		window.location = link;
	});

	/* Load More Posts */
	new BjzmLoadMorePosts();


	var subMenuScroll = new SinglePageUpdown({
		container: $(".home-hero__scroll-more, .submenu, .navigation__menu--condo, .navigation__menu--floor-plans, .home-slider-content__item,  .navigation__menu--condo, .mobile-scroller__list"),
		offset: 130,
		sectionSelector: '.anchor-section',
		activeClass: 'current-anchor-item',
		navContainer: '.submenu, .navigation__menu--condo',
		callBack: function() {
			 ThemeScripts.closeMobileMenu();
			 if( $('.header--main').hasClass('sticky-anchors') ) {
			 	// $('.header--main').removeClass('sticky-anchors');
			 }
		},
		beforeScroll: function() {
			 if( $('.header--main').hasClass('scrolled') ) {
			 	$('.header--main').addClass('sticky-anchors');
			 }
		}
	});

	var doMobileScrollerMenu = function() {
		BJZM_DATA.ID;
		var mainMenuClass = `.navigation--main .page-item-${BJZM_DATA.ID}`;

		if( $(mainMenuClass).has('ul').length > 0 ) {
			if( $(mainMenuClass).hasClass('current-menu-item') ) {
				var innerHtml = $(mainMenuClass).find('.navigation__submenu').html();
				$(".mobile-scroller__list").html(innerHtml);
				setTimeout(function(){
					$(".mobile-scroller").addClass('mobile-scroller--active');

					new SinglePageUpdown({
						container: $(".mobile-scroller__list"),
						offset: 60,
						sectionSelector: '.anchor-section',
						activeClass: 'current-anchor-item',
						navContainer: '.mobile-scroller__list',
					});

				}, 300);
			}
		}
	}

	doMobileScrollerMenu();

	/* Header Scroll */
	var MainHeaderScroll = new HeaderScroll({
		getIsScrolling: subMenuScroll.getIsScrolling(),
	});


	

	/*privacy policy*/
	$('.lightbox').magnificPopup({
 		type: 'inline',
		midClick: true,
		removalDelay: 300,
		mainClass: 'mfp-fade mfp-wrap--privacy-policy'
	});


	$(".show-hero").change(function(){
		$(".home-wrapper").toggleClass('hero-map');
	});




});









